<template>
    <div class="captcha" :class="{ [extraClass]: true }">
        <input
            placeholder="请输入验证码"
            :value="value"
            @input="$emit('input', $event.target.value)"
            type="number"
            class="captcha__input">
        <button class="captcha__send" :disabled="isCount" @click="sendCaptcha">
            {{ isCount ? `${countTime}s后重试` : '发送验证码' }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        account: {
            type: String,
            required: true,
        },
        extraClass: {
            type: String,
            default: '',
        },
        value: String,
    },
    data() {
        return {
            isCount: false,
            countTime: 120,
        };
    },
    methods: {
        sendCaptcha() {
            this.$axios.post('/tuchongapi/captcha/sms', {
                mobile_number: this.account,
            }).then(() => {
                this.isCount = true;
                this.countHandler = setInterval(() => {
                    this.countTime -= 1;
                    if (this.countTime <= 0) {
                        this.isCount = false;
                        clearInterval(this.countHandler);
                    }
                }, 1000);
            });
        },
    },
    unmounted() {
        this.countHandler && clearInterval(this.countHandler);
    },
};
</script>

<style scope lang="scss">
.captcha {
    display: block;
    width: 2.5rem;
    color: #c0c0c0;
    background-color: rgba(255, 255, 255, .15);
    padding: .15rem .2rem;
    margin: .2rem auto;
    border-radius: .02rem;

    &__input {
        color: #c0c0c0;
        width: 1.1rem;
        margin-right: 0.1rem;
        background-color: transparent;
    }

    &__send {
        width: .9rem;
        padding: 0;
        background-color: transparent;
        color: #ffae00;
    }
}
</style>
